import styled from "styled-components";
import { Modal } from "antd";

export const StyledModal = styled(Modal)`
  .ant-modal-content {
    padding: 0;
    overflow: hidden;
    border-radius: 16px;
  }
`;

export const ModalBody = styled.div`
  padding: 40px;
  min-height: 320px;
  position: relative;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  width: 32px;
  height: 32px;
  border: none;
  background: transparent;
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  font-size: 16px;
  transition: all 0.2s;

  &:hover {
    background: #f0f0f0;
    color: #555;
  }
`;

export const PanelHeader = styled.div`
  margin-bottom: 24px;

  h3 {
    margin: 0 0 4px 0;
    font-size: 22px;
    font-weight: 700;
    color: #1a1a2e;
  }

  p {
    margin: 0;
    font-size: 14px;
    color: #8a8a9a;
  }
`;

export const AmountDisplay = styled.div`
  background: #eef4fb;
  border: 1px solid #d4e4f5;
  border-radius: 10px;
  padding: 14px 18px;
  margin-bottom: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  span.label {
    font-size: 14px;
    color: #4a4a5a;
  }

  span.amount {
    font-size: 20px;
    font-weight: 700;
    color: #1e5799;
  }
`;

export const FormFields = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 20px;
`;

export const FieldLabel = styled.label`
  display: block;
  font-weight: 600;
  margin-bottom: 6px;
  font-size: 13px;
  color: #4a4a5a;
`;

export const FieldError = styled.span`
  color: #ff4d4f;
  font-size: 12px;
  margin-top: 2px;
  display: block;
`;

export const AlertsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 20px 0;
`;

export const ActionButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;

  .pay-btn {
    min-width: 180px;
    background: linear-gradient(135deg, #1e5799 0%, #2471a3 100%);
    border: none;
    border-radius: 10px;
    font-weight: 600;

    &:hover:not(:disabled) {
      background: linear-gradient(135deg, #174a85 0%, #1d6290 100%);
    }
  }

  .cancel-btn {
    border-radius: 10px;
  }
`;

export const OtpInputRow = styled.div`
  display: flex;
  justify-content: center;
  margin: 24px 0;

  .ant-otp {
    gap: 10px;
  }
`;

export const CountdownRow = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 16px;

  .ant-statistic-content {
    font-size: 18px;
    color: #1e5799;
  }
`;

export const ManualTransferBox = styled.div`
  border-radius: 10px;
  margin-bottom: 20px;
`;
